import { createUniqueFieldSchema } from '@ts-react/form'
import { z } from 'zod'

export const PhoneNumberSchema = createUniqueFieldSchema(z.string(), 'phoneNumber')
